package api


sealed class TouchscreenRotation(var value: Int, val label: String) {
    /** 2 */
    data object DEFAULT : TouchscreenRotation(2, "DEFAULT")

    /** 4 */
    data object HORIZONTAL : TouchscreenRotation(4, "HORIZONTAL")

    /** 8 */
    data object VERTICAL : TouchscreenRotation(8, "VERTICAL")

    /** 16 */
    data object REVERSED_HORIZONTAL : TouchscreenRotation(16, "REVERSED_HORIZONTAL")

    /** 32 */
    data object REVERSED_VERTICAL : TouchscreenRotation(32, "REVERSED_VERTICAL")

    infix fun match(value: Int): Boolean = this.value and value > 0

    companion object {

        val all by lazy {
            arrayOf(DEFAULT, HORIZONTAL, VERTICAL, REVERSED_HORIZONTAL, REVERSED_VERTICAL)
        }

        operator fun get(value: Int): TouchscreenRotation {
            return all.firstOrNull { it match value } ?: DEFAULT
        }
    }
}
